import { classnames } from 'Utils/classnames/classnames.utils';

import { COLORS, COMPLEMENTARY_COLORS } from 'Components/utils/color/colors';

type ThemeArgs = {
  color?: string;
  isAccordion?: boolean;
  isActive?: boolean;
};

export const themes = {
  default: ({ color = COLORS.SAFFRON, isAccordion, isActive }: ThemeArgs) => ({
    thRoot: classnames(
      'flex items-center gap-5 whitespace-nowrap rounded-pill px-20 py-10 font-sans text-16 font-bold text-black transition-colors duration-250 ease-in',
      {
        [`border-1 border-${color}`]: isAccordion,
        [`bg-white hocus:bg-${color} hocus:text-${COMPLEMENTARY_COLORS[color]}`]: !isActive,
        [`bg-${color} text-${COMPLEMENTARY_COLORS[color]}`]: isActive,
      },
    ),
    thIcon: 'shrink-0',
    thIconWidth: '1em',
  }),
  simple: ({ color = COLORS.SAFFRON, isActive }: ThemeArgs) => ({
    thRoot: classnames(
      'flex items-center gap-5 rounded-12 border-1 p-10 text-center font-sans text-12 font-bold uppercase transition-colors duration-250 ease-in',
      {
        [`bg-white hocus:bg-${color} border-lightGrey hocus:border-${color} hocus:text-${COMPLEMENTARY_COLORS[color]}`]:
          !isActive,
        [`arrow-down arrow-${color} bg-${color} border-${color} text-${COMPLEMENTARY_COLORS[color]}`]:
          isActive,
      },
    ),
    thIcon: 'shrink-0',
    thIconWidth: '1em',
  }),
  underlined: ({ color = COLORS.SIENNA, isActive }: ThemeArgs) => ({
    thRoot: classnames(
      'flex h-full shrink-0 items-center gap-5 overflow-hidden border-b-2 border-current text-16 font-bold',
      {
        'text-mediumGrey': !isActive,
        [`text-${color}`]: isActive,
      },
    ),
    thIcon: 'shrink-0',
    thIconWidth: '1em',
  }),
  rounded: ({ color = COLORS.SIENNA, isActive }: ThemeArgs) => ({
    thRoot: classnames(
      'flex items-center gap-5 overflow-hidden rounded-t-12 border-1 border-lightGrey',
      {
        'bg-pearl': !isActive,
        [`arrow-down-top arrow-${color} border-b-0 bg-white`]: isActive,
      },
    ),
    thIcon: 'shrink-0',
    thIconWidth: '1em',
  }),
  flat: ({ isActive }: ThemeArgs) => ({
    thRoot: classnames(
      'flex h-full items-center rounded-2 border-1 p-10 transition-colors duration-250 ease-in md:px-20',
      {
        'bg-pearl': !isActive,
        'border-b-0 bg-white': isActive,
      },
    ),
    thIcon: 'shrink-0',
    thIconWidth: '1em',
  }),
};
